import { Button, HFlow, Tooltip } from 'bold-ui'
import { DateField, Form, FormRenderProps } from 'components/form'
import { useAtendimentoContext } from 'hooks/atendimento-context/useAtendimentoContext'
import React from 'react'
import { toDate } from 'util/date/formatDate'
import { isObjectDeepFalsy } from 'util/object'

import { meta, PreNatalDumModel } from './model-preNatalDumSection'

interface PreNatalDumFormProps {
  onSubmit: (values: PreNatalDumModel) => void
  onCancel: () => void
  initialValues: PreNatalDumModel
  required: boolean
  dataTestId?: string
}

export function PreNatalDumForm(props: Readonly<PreNatalDumFormProps>) {
  const { onSubmit, onCancel, initialValues, required, dataTestId } = props

  const {
    cidadao: { dataNascimento },
    atendimentoProfissional: { iniciadoEm },
  } = useAtendimentoContext()

  const renderForm = (renderFormProps: FormRenderProps<PreNatalDumModel>) => {
    const { initialValues, values, handleSubmit } = renderFormProps

    const isRequiredAndInitiallyEmpty = required && isObjectDeepFalsy(initialValues)
    const isRequiredAndNotFilled = required && isObjectDeepFalsy(values)
    const isInitiallyEmptyAndNotFilled = isObjectDeepFalsy(initialValues) && isObjectDeepFalsy(values)

    const cancelarButtonTooltip = isRequiredAndInitiallyEmpty ? 'Obrigatório informar DUM' : ''
    const salvarButtonTooltip = isRequiredAndNotFilled
      ? 'Obrigatório informar DUM'
      : isInitiallyEmptyAndNotFilled
      ? 'Preencha DUM para salvar'
      : ''

    return (
      <HFlow alignItems='center' hSpacing={1} data-testid={dataTestId}>
        <DateField name={meta.dum} minDate={toDate(dataNascimento)} maxDate={iniciadoEm} allowNull />
        <Tooltip text={cancelarButtonTooltip}>
          <Button kind='normal' size='small' skin='outline' onClick={onCancel} disabled={isRequiredAndInitiallyEmpty}>
            Cancelar
          </Button>
        </Tooltip>
        <Tooltip text={salvarButtonTooltip}>
          <Button
            kind='primary'
            size='small'
            skin='outline'
            onClick={handleSubmit}
            disabled={isRequiredAndNotFilled || isInitiallyEmptyAndNotFilled}
          >
            Salvar
          </Button>
        </Tooltip>
      </HFlow>
    )
  }

  return <Form<PreNatalDumModel> render={renderForm} onSubmit={onSubmit} initialValues={initialValues} />
}
